import renderIcon from 'helpers/renderIcon';
import * as React from 'react';

interface IProps {
	// form values
	input: any;
	onChangeAction: (x: number) => void;
}

const ReviewScoreSetter = (props: IProps) => {
	const score = Math.min(Math.max(0, parseInt(props.input?.value, 10) || 0), 5);

	const star = (value: number): JSX.Element => {
		const handleClick = () => {
			props.input.onChange(value);
		};
		return (
			<div onClick={handleClick} className="pointer" tabIndex={1} key={value}>
				{renderIcon('star1', 20, 20, value <= score ? '' : 'gray')}
			</div>
		);
	};

	const renderStars = (numberOfStars: number): JSX.Element[] => {
		const componentArray: JSX.Element[] = [];
		for (let i = 1; i <= numberOfStars; i++) {
			componentArray.push(star(i));
		}
		return componentArray;
	};

	return <div className="review-score-setter d-flex flex-row align-items-center">{renderStars(5)}</div>;
};

export default ReviewScoreSetter;
